const ko = {
  ID_ACTION_ANIMATION_HI: "Hi",
  ID_ACTION_ANIMATION_GOOD: "Good",
  ID_ACTION_ANIMATION_PICK: "Pick",
  ID_ACTION_ANIMATION_SIT: "Sit",
  ID_ACTION_ANIMATION_SCARE: "Scare",
  ID_ACTION_ANIMATION_DANCE: "Dance",
};

export default ko;
